import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IUser, IUserRole } from 'modules/auth-session';

import { IUsersModal } from '../types/users.types';

interface UsersState extends BaseDataReducerInitialState<IUser> {
  perPage: number;
  availableRoles: IUserRole[];
  selectedUser: IUser | null;
  editableUser: IUser | null;
  currentModal: IUsersModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IUser, UsersState>('app-users');

const usersState: UsersState = {
  ...initialState,
  perPage: 10,
  availableRoles: [],
  currentModal: null,
  selectedUser: null,
  editableUser: null,
};

export const users = createSlice({
  name: 'users',
  initialState: usersState,
  reducers: {
    setSelectedUser(state, action: PayloadAction<IUser | null>) {
      state.selectedUser = action.payload;
    },
    setAvailableRoles(state, action: PayloadAction<IUserRole[]>) {
      state.availableRoles = action.payload;
    },
    setUsersModal(state, action: PayloadAction<IUsersModal | null>) {
      state.currentModal = action.payload;
    },
    setEditableUser(state, action: PayloadAction<IUser | null>) {
      state.editableUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as UsersState, action);
    });
  },
});
export const UsersAC = AC;
export const onUsersSort = thunks.onSort;
export const onUsersFilter = thunks.onFilter;
export const setUsersCurrentPage = AC.setCurrentPage;

export const { setAvailableRoles, setSelectedUser, setUsersModal, setEditableUser } = users.actions;
